import { useEffect } from "react";
import { toast } from "sonner";
import { Flash } from "@/types";

export function useFlash(flash: Flash) {
  // Add state to detect visits from back/forward navigation
  useEffect(() => {
    const handlePopstate = () => {
      sessionStorage.setItem("isBackNavigation", "true");
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  useEffect(() => {
    // Do not display flash messages on back/forward navigation
    if (sessionStorage.getItem("isBackNavigation") === "true") {
      sessionStorage.removeItem("isBackNavigation");
      return;
    }

    if (flash.alert) {
      const toastId = toast.error(flash.alert);
      return () => {
        toast.dismiss(toastId);
      };
    }

    if (flash.notice) {
      const toastId = toast.success(flash.notice);
      return () => {
        toast.dismiss(toastId);
      };
    }
  }, [flash.alert, flash.notice]);
}
